import { render, staticRenderFns } from "./CampusHeader.vue?vue&type=template&id=c078dd6a&"
import script from "./CampusHeader.vue?vue&type=script&lang=ts&"
export * from "./CampusHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports